import axios from 'axios';
import { useMutation, useQuery } from 'react-query';

import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';
import { Layer3DProjectionConfig } from '../models/types/Layer3DProjectionConfig';
import { Layer3DProjectionData } from '../models/types/Layer3DProjectionData';
import { AmplitudeDomain } from '../models/enums/AmplitudeDomain';

export const useGet3DProjectionConfigList = (enabled: boolean = true) => {
    const [ host, jwt] = useSessionStore(state => [state.tenantConfiguration?.endpoints.projections3D, state.jwtToken]);

    return useQuery(
        ['ProjectionList'],
        async () => {
            const response = await axios.get<IResponseAPI<Layer3DProjectionConfig[]>>(host + '/Seismic3D/GetProjectionConfigList', {
                headers: {
                    Authorization: 'Bearer ' + jwt,
                }
            });
            return response.data.Result;
        }, {
            enabled
        }
    );
};

export const useGet3DProjectionData = () => {
    const [ host, jwt] = useSessionStore(state => [state.tenantConfiguration?.endpoints.projections3D, state.jwtToken]);

    return useMutation(async (params: { geomWkt: string, token: string, geomSrid: number, domain: AmplitudeDomain }) => {
        const response = await axios.post<IResponseAPI<Layer3DProjectionData[]>>(host + '/Seismic3D/GetProjectionConfigData', params, {
            headers: {
                Authorization: 'Bearer ' + jwt
            }
        });

        return response.data.Result;
    });
};